import { useGraphQLQuery } from '@opengov/bnp-core';
import isEmpty from 'lodash/isEmpty';
import { HASURA_SERVICE_URL } from '../../../../../../config/config';
import { graphql } from '../../../../../../gql-generated/hasura';
import { useToast } from '../../../../Toast/context/useToast.context';
import locale from '../../customReports-locale.json';
import { editCustomSpreadsheetModalQueryKeys } from './editCustomSpreadsheetModalQueryKeys';

const FetchSpreadsheetNamedRangesQuery = graphql(`
  query GetSpreadsheetNamedRanges($spreadsheetId: uuid!) {
    spreadsheetNamedRanges(where: { spreadsheetId: { _eq: $spreadsheetId } }) {
      id
      name
    }
  }
`);

export function useFetchNamedRangesForEditMediaModal({ spreadsheetId }: { spreadsheetId: string }) {
  const { toggleToast } = useToast();
  return useGraphQLQuery({
    queryKey: editCustomSpreadsheetModalQueryKeys.namedRanges(spreadsheetId),
    variables: { spreadsheetId: spreadsheetId },
    document: FetchSpreadsheetNamedRangesQuery,
    url: HASURA_SERVICE_URL,
    options: {
      enabled: !isEmpty(spreadsheetId),
      onError: (error) => {
        console.error(error);
        toggleToast({
          title: locale.errors.somethingWentWrong,
          body: locale.errors.unableToFetchNamedRanges,
          severity: 'error'
        });
      }
    }
  });
}
